/**
 * This component is used as a replacement for the MockApiModal when NODE_ENV is
 * not 'development' so that the mocks and mock api code is not included in the
 * build output. It is necessary to keep this in a separate file to eliminate
 * MSW related code and mock data from the dependency tree at build time.
 */

import { AnyObject } from 'syf-js-utilities'

const NullComponent: React.FC<AnyObject> = () => null

export default NullComponent
